import React from 'react';
import {
    SectionWrapper,
    SectionHeader,
    SectionSubtitle,
    WarrantyTable,
    TableHead,
    TableBody,
    TableRow,
    TableHeader,
    TableCell
} from './WarrantySection.style';
import type { WarrantySectionProps } from '../../types/VehicleSectionProps';
import { Heading } from '@makemydeal/dr-ui-bricks-components';
import { useWarrantyCoverageCdlEvent } from '../../hooks';

export const WarrantySection: React.FC<WarrantySectionProps> = ({ warranties, inServiceDateLabel }) => {
    const sectionRef = useWarrantyCoverageCdlEvent();

    return (
        <SectionWrapper ref={sectionRef} data-testid="warranty-section">
            <SectionHeader>
                <Heading level={6} weight="bold">
                    Warranty Coverage
                </Heading>
                {inServiceDateLabel && (
                    <SectionSubtitle size="small" weight="regular" data-testid="warranty-in-service-date">
                        {inServiceDateLabel}
                    </SectionSubtitle>
                )}
            </SectionHeader>

            <WarrantyTable>
                <TableHead>
                    <TableRow>
                        <TableHeader>Coverage Type</TableHeader>
                        <TableHeader>Time</TableHeader>
                        <TableHeader>Mileage</TableHeader>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {warranties.map((item, index) => (
                        <TableRow key={index} data-testid={`warranty-row-${index}`}>
                            <TableCell data-testid={`warranty-type-${index}`}>{item.description}</TableCell>
                            <TableCell data-testid={`warranty-time-${index}`}>{item.formattedMonths}</TableCell>
                            <TableCell data-testid={`warranty-miles-${index}`}>{item.formattedMiles}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </WarrantyTable>
        </SectionWrapper>
    );
};
